import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateRecruitmentFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.recruitmentsUpdateFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.recruitmentsFilters]);
    },
  });
};
